<div style="position: absolute;top: 0;left: 0;width: 100%;">
  <nav class="navbar navbar-expand navbar-white navbar-light"
  style="margin-left: 0px;border-bottom: 1px solid #B5B5B6; padding-left: 0;">
    <a [routerLink]="['/home']">
    <img
        alt="AdminLTE Logo"
        class="brand-image"
        src={{logoUrl}}
      /></a>
  </nav>
</div>
<div class="login-box">
  <div class="login-logo">
    <i class='correct'></i>
    <p style="margin-top: -6px;" class="title-login">{{ 'MY_ACCOUNT.EMAIL_CORRECT_TEXT_1' | translate }}</p>
  </div>
  <div class="text-center" style="padding-top: 24px;">
    <p>{{ 'MY_ACCOUNT.EMAIL_CORRECT_TEXT_2' | translate }}</p>
  </div>
</div>
<!-- Loader -->
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#E10800 " type="square-jelly-box" [fullScreen]="true">
  <p style="color: #E10800 "> {{ 'COMMON.LOADING' | translate }} </p>
</ngx-spinner>